import API from "./api";

// Get customer list report (JSON format)
export const getCustomerListReport = async () => {
    try {
        const response = await API.get("/reports/customers");
        return response.data;
    } catch (error) {
        console.error("Error fetching customer list report:", error);
        throw error.response?.data || error.message;
    }
};

// Download customer list as Excel
export const downloadCustomerListExcel = async () => {
    try {
        const response = await API.get("/reports/customers?format=excel", {
            responseType: "blob"
        });

        // Create a download link and trigger download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `customer_list_${new Date().toISOString().split("T")[0]}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();

        return true;
    } catch (error) {
        console.error("Error downloading customer list Excel:", error);
        throw error.response?.data || error.message;
    }
};

// Get product list report (JSON format)
export const getProductListReport = async () => {
    try {
        const response = await API.get("/reports/products");
        return response.data;
    } catch (error) {
        console.error("Error fetching product list report:", error);
        throw error.response?.data || error.message;
    }
};

// Download product list as Excel
export const downloadProductListExcel = async () => {
    try {
        const response = await API.get("/reports/products?format=excel", {
            responseType: "blob"
        });

        // Create a download link and trigger download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `product_list_${new Date().toISOString().split("T")[0]}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();

        return true;
    } catch (error) {
        console.error("Error downloading product list Excel:", error);
        throw error.response?.data || error.message;
    }
};

// Get sales revenue report (JSON format)
export const getSalesReport = async (startDate, endDate) => {
    try {
        const response = await API.get(`/reports/sales?startDate=${startDate}&endDate=${endDate}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching sales report:", error);
        throw error.response?.data || error.message;
    }
};

// Download sales report as PDF
export const downloadSalesReportPDF = async (startDate, endDate, setDownloadReady) => {
    try {
        const response = await API.get(
            `/reports/sales?startDate=${startDate}&endDate=${endDate}&format=pdf`,
            { responseType: "blob" }
        );

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `sales_report_${new Date().toISOString().split("T")[0]}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();

        setDownloadReady(url);
    } catch (error) {
        console.error("Error downloading sales report PDF:", error);
    }
};


// Get repair income report (JSON format)
export const getRepairReport = async (startDate, endDate) => {
    try {
        const response = await API.get(`/reports/repairs?startDate=${startDate}&endDate=${endDate}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching repair report:", error);
        throw error.response?.data || error.message;
    }
};

export const downloadRepairReportPDF = async (startDate, endDate) => {
    try {
        const response = await API.get(
            `/reports/repairs?startDate=${startDate}&endDate=${endDate}&format=pdf`
        );

        if (response.data.success && response.data.downloadURL) {
            return response.data.downloadURL; // ✅ Return correct file URL
        } else {
            throw new Error("Failed to generate repair report");
        }
    } catch (error) {
        console.error("Error downloading repair report PDF:", error);
        throw error.response?.data || error.message;
    }
};

